module.exports = __webpack_public_path__ + "img/logos.d46fa264.png";